import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import challengesService from "../../services/challengesService";

const initialState = {
  challengesCategories: [],
  challengesList: [],
  challengeInfo: [],
  kidsChallenges: [],
  ownerChallenges: [],
};

export const get_categories_list = createAsyncThunk(
  "challenges/getCategories",
  () => {
    return challengesService
      .getChallengesCategoriesList()
      .then((response) => response.data);
  }
);

export const get_challenge_list = createAsyncThunk(
  "challenges/getChallengesList",
  (categoryId) => {
    return challengesService
      .getChallengesList(categoryId)
      .then((response) => response.data);
  }
);

export const get_more_challenge_list = createAsyncThunk(
  "challenges/getMoreChallengesList",
  (url) => {
    return challengesService
      .getMoreChallengesList(url)
      .then((response) => response.data);
  }
);

export const get_challenge_info = createAsyncThunk(
  "challenges/getChallengeInfo",
  ({ categoryId, challengeId }) => {
    return challengesService
      .getChallengeInfo(categoryId, challengeId)
      .then((response) => response.data);
  }
);

export const get_kids_challenge = createAsyncThunk(
  "challenges/getKidsChallenges",
  ({ categoryId, challengeId }) => {
    return challengesService
      .getKidsChallenges(categoryId, challengeId)
      .then((response) => response.data);
  }
);

export const get_more_kids_challenge = createAsyncThunk(
  "challenges/getMoreKidsChallenges",
  (url) => {
    return challengesService
      .getMoreKidsChallenges(url)
      .then((response) => response.data);
  }
);

export const get_owner_challenge = createAsyncThunk(
  "challenges/getOwnerChallenges",
  ({ categoryId, challengeId, userId }) => {
    return challengesService
      .getOwnerChallenges(categoryId, challengeId, userId)
      .then((response) => response.data);
  }
);

const challengeSlice = createSlice({
  name: "challenges",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(get_categories_list.fulfilled, (state, action) => {
      state.challengesCategories = action.payload;
    });
    builder.addCase(get_challenge_list.fulfilled, (state, action) => {
      state.challengesList = action.payload;
    });
    builder.addCase(get_more_challenge_list.fulfilled, (state, action) => {
      state.challengesList.count = action.payload.count;
      state.challengesList.next = action.payload.next;
      state.challengesList.results = state.challengesList.results.concat(action.payload.results);
    });
    builder.addCase(get_challenge_info.fulfilled, (state, action) => {
      state.challengeInfo = action.payload;
    });
    builder.addCase(get_kids_challenge.fulfilled, (state, action) => {
      state.kidsChallenges = action.payload;
    });
    builder.addCase(get_more_kids_challenge.fulfilled, (state, action) => {
      state.kidsChallenges.count = action.payload.count;
      state.kidsChallenges.next = action.payload.next;
      state.kidsChallenges.results = state.kidsChallenges.results.concat(action.payload.results);
    });
    builder.addCase(get_owner_challenge.fulfilled, (state, action) => {
      state.ownerChallenges = action.payload;
    });
  },
});

export default challengeSlice.reducer;
